import { Nav, NavItem, NavLink, Badge } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormattedMessage } from "react-intl";
import classNames from "classnames";

export default function TabNav({
  level,
  handlePostNavTab,
  tab,
  isMobile = false,
  aplUnviewedCount = 0,
}) {
  const linkClass = (id) =>
    classNames("teacher-tab-link", {
      "teacher-tab-link--active": tab === id,
      "teacher-tab-link--inactive": tab !== id,
    });

  return (
    <Nav
      tabs
      className={classNames("bg-primary border-0", {
        "teacher-tab--mobile": isMobile,
      })}
    >
      <NavItem onClick={() => handlePostNavTab(1)}>
        <NavLink className={linkClass(1)}>
          <FontAwesomeIcon icon="map" />
          <FormattedMessage id="Admin" />
        </NavLink>
      </NavItem>

      <NavItem onClick={() => handlePostNavTab(2)}>
        <NavLink className={linkClass(2)}>
          <FontAwesomeIcon icon="book-open" />
          <FormattedMessage id="Courses" />
        </NavLink>
      </NavItem>

      <NavItem onClick={() => handlePostNavTab(3)}>
        <NavLink className={linkClass(3)}>
          <FontAwesomeIcon icon="chart-pie" />
          <FormattedMessage id="ResultsOverview" />
        </NavLink>
      </NavItem>
      {level === "class" ? (
        <>
          <NavItem onClick={() => handlePostNavTab(5)}>
            <NavLink className={linkClass(5)}>
              <FontAwesomeIcon icon="chalkboard-teacher" />
              <FormattedMessage id="Documents" />
            </NavLink>
          </NavItem>
        </>
      ) : (
        ""
      )}
      <NavItem onClick={() => handlePostNavTab(7)}>
        <NavLink style={{ isolation: "isolate" }} className={linkClass(7)}>
          <FontAwesomeIcon icon="briefcase" />
          <FormattedMessage id="APL" />
          {aplUnviewedCount > 0 && (
            <Badge color="danger" pill className="ms-2">
              {aplUnviewedCount}
            </Badge>
          )}
        </NavLink>
      </NavItem>
    </Nav>
  );
}
